import React from 'react';

import DropdownItem from '@atlaskit/dropdown-menu/dropdown-menu-item';
import ClockIcon from '@atlaskit/icon/core/clock';
import { useAnalyticsEvents } from '@atlaskit/analytics-next/useAnalyticsEvents';

import { fg } from '@confluence/feature-gating';
import { expVal } from '@confluence/feature-experiments';

type ViewPageHistoryMenuItemProps = {
	label: string;
	isLivePage: boolean;
	contentType: string;
	itemId?: string;
	itemUrl?: string;
};

export const ViewPageHistoryMenuItem = ({
	label,
	isLivePage,
	contentType,
	itemId = '',
	itemUrl = '',
}: ViewPageHistoryMenuItemProps): React.JSX.Element => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	return (
		<DropdownItem
			key={itemId}
			elemBefore={<ClockIcon label="" />}
			href={itemUrl}
			onClick={() => {
				createAnalyticsEvent({
					type: 'sendUIEvent',
					data: {
						action: 'clicked',
						actionSubject: 'button',
						actionSubjectId: 'versionHistory',
						source: 'overflowMenu',
						attributes: {
							isContentWrapper: fg('confluence_frontend_content_wrapper'),
							isNewContentHistory: expVal('confluence_content_history_updates', 'isEnabled', false),
							isLivePage,
							contentType,
						},
					},
				}).fire();
			}}
		>
			{label}
		</DropdownItem>
	);
};
